import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { EnrollmentHelper } from '@rd/helpers/enrollment.helper';
import { Enrollment } from '@rd/types';
import { RedeemCashV2LinkAccountFormData } from '../../types';

@Component({
  selector: 'rd-rcv2-link-account-form',
  templateUrl: './link-account-form.component.html',
  styleUrls: ['./link-account-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RcV2LinkAccountFormComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RcV2LinkAccountFormComponent
  implements OnInit, ControlValueAccessor
{
  @HostBinding('class.rd-rcv2-link-account-form') componentClass = true;

  @Input() formData: RedeemCashV2LinkAccountFormData;
  @Input() enrollments: Enrollment[];
  @Input() isSubmitted: boolean;
  @Input() shouldAllowRedeemToOtherAccount: boolean;
  @Output() enrollmentChange = new EventEmitter<boolean>();

  propagateChange: (value: any) => {};
  formGroup: UntypedFormGroup;
  onTouched: () => void = () => {};

  constructor(
    private enrollmentHelper: EnrollmentHelper,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      enrollment: this.formData ? this.formData.enrollment : '',
    });

    Promise.resolve().then(() => this.propagateChange(this.formGroup.value));
  }

  // ControlValueAccessor methods

  writeValue(val: any): void {
    if (!!val) {
      this.formGroup.setValue(val, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.formGroup.valueChanges.subscribe(fn);
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChangeEnrollment(event: MatRadioChange): void {
    this.enrollmentChange.emit(!event.value);
  }

  // Display methods/helpers

  displayedAccountNumber(accountNumber: string): string {
    return this.enrollmentHelper.displayedAccountNumber(accountNumber);
  }

  productType(enrollment: Enrollment): string | undefined {
    return this.enrollmentHelper.productTypeFromProductCode(enrollment);
  }
}
